<template>
  <b-modal
    title="Change Your Password"
    body-bg-variant="light"
    header-bg-variant="dark"
    header-text-variant="white"
    hide-footer
    @show="onShow"
    v-model="isShown"
    centered
  >
    <b-form-group label="Old Password:" label-cols-sm="5" label-align-sm="right">
      <b-input-group>
        <b-input :type="passwordVisible ? 'text' : 'password'" v-model="oldPassword" :state="validated('oldPassword')" />
        <b-input-group-addon>
          <b-button size="sm" @click="passwordVisible = !passwordVisible" tabindex="-1">
            <b-icon :icon="passwordVisible ? 'eye' : 'eye-slash'" />
          </b-button>
        </b-input-group-addon>
        <b-form-invalid-feedback>Old Password is Required</b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
    <b-form-group label="New Password:" label-cols-sm="5" label-align-sm="right">
      <b-input-group>
        <b-input :type="passwordVisible ? 'text' : 'password'" v-model="newPassword" :state="validated('newPassword')" />
        <b-input-group-addon>
          <b-button size="sm" @click="passwordVisible = !passwordVisible" tabindex="-1">
            <b-icon :icon="passwordVisible ? 'eye' : 'eye-slash'" />
          </b-button>
        </b-input-group-addon>
        <b-form-invalid-feedback>{{ newPasswordFeedback }}</b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>

    <b-form-group v-if="newPasswordValue.length > 0" label="" label-cols-sm="5" class="mb-2">
      <password-requirements :value="newPasswordValue" compact note-label="included" />
    </b-form-group>

    <b-form-group label="Repeat New Password:" label-cols-sm="5" label-align-sm="right">
      <b-input-group>
        <b-input :type="passwordVisible ? 'text' : 'password'" v-model="newPasswordRepeat" :state="validated('newPasswordRepeat')" />
        <b-input-group-addon>
          <b-button size="sm" @click="passwordVisible = !passwordVisible" tabindex="-1">
            <b-icon :icon="passwordVisible ? 'eye' : 'eye-slash'" />
          </b-button>
        </b-input-group-addon>
        <b-form-invalid-feedback>Passwords do not match</b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
    <b-form-group label="" label-cols-sm="5" label-align-sm="right">
      <b-button-group size="sm">
        <b-button variant="success" :disabled="showShade || changeButtonDisabled" @click="onChangeClick">Change Password</b-button>
        <b-button variant="danger" :disabled="showShade" @click="isShown = false">Cancel</b-button>
      </b-button-group>
    </b-form-group>
  </b-modal>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'underscore';
import passwordMixin from '@/mixins/password_mixin';
import PasswordRequirements from '@/components/PasswordRequirements';

@Component({
  mixins: [passwordMixin],
  components: { PasswordRequirements }
})
export default class ChangePasswordModal extends Vue {
  @Prop({ type: Boolean, default: false }) value;
  passwordVisible = false;
  oldPassword = null;
  newPassword = null;
  newPasswordRepeat = null;

  showShade = false;

  get password() {
    return this.newPassword;
  }

  get newPasswordValue() {
    return this.passwordValue;
  }

  get passwordStrengthVariant() {
    return this.isStrongPassword ? 'success' : 'danger';
  }

  get isShown() {
    return this.value;
  }

  set isShown(value) {
    this.$emit('input', value);
  }

  async onChangeClick() {
    if (!this.isStrongPassword) {
      return this.$bvToast.toast('Please correct the highlighted errors.', {
        title: 'Error',
        solid: true,
        variant: 'danger'
      });
    }

    try {
      this.showShade = true;
      await this.$store.dispatch('session/changePassword', {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      });
      this.isShown = false;

      this.$bvToast.toast('You have successfully changed your password!', {
        title: 'Password Changed',
        solid: true,
        variant: 'success'
      });
    } catch (error) {
      const message = error && error.message ? error.message : 'An unknown error occurred, please try again';

      this.$bvToast.toast(message, {
        title: 'Error',
        solid: true,
        variant: 'danger'
      });
    } finally {
      this.showShade = false;
    }
  }

  get changeButtonDisabled() {
    return ['oldPassword', 'newPassword', 'newPasswordRepeat'].some(k => !this.validated(k));
  }

  get newPasswordFeedback() {
    return this.passwordFeedback;
  }

  validated(field) {
    const value = (this[field] || '').trim();
    switch (field) {
      case 'oldPassword':
        return 0 < value.length;
      case 'newPassword':
        return !this.passwordFeedback;
      case 'newPasswordRepeat':
        if (_((this.newPassword ?? '').trim()).isEmpty()) {
          return undefined;
        }

        return !_((this.newPasswordRepeat ?? '').trim()).isEmpty() && this.newPassword === this.newPasswordRepeat;
      default:
        return true;
    }
  }

  onShow() {
    ['oldPassword', 'newPassword', 'newPasswordRepeat'].forEach(k => (this[k] = ''));
  }
}
</script>
<style scoped></style>
